import { Form } from 'factorial-form'

export const FormActions = {
  export_all: 'all',
  export_only_reference: 'only_reference',
}

export class ImportModeForm extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      mode: 'string',
    })
  }
}
